// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingScreen_container__TovQH","text":"LoadingScreen_text__8eRqg"};